import React from "react";
import Type from "../../utils/icons/Type";
import {
  closePopUp,
  showAlertPopUp,
  showLoadingPopUp,
  showPopUp,
} from "../../utils/Overlay";
import { verifyMaxNumberOfContentItems } from "./utils";
import ContentText, { TYPE_OF_TEXT } from "../ContentText";
import { createSnippetRequest, saveContent } from "../../../apis/firebase";
import { ContentType } from "../../../constants";
import { trackEvent } from "../../helpers";

const handleTextSave = async (
  post: Post,
  text,
  content: Content,
  options: NewTextMeta
) => {
  showLoadingPopUp("Saving your text.");
  try {
    if (options.typeOfText === TYPE_OF_TEXT.PLAIN_TEXT) {
      await saveContent(post.id, {
        id: content ? content.id : undefined,
        type: ContentType.TEXT,
        value: text,
      });
      closePopUp();
    } else if (options.typeOfText === TYPE_OF_TEXT.CODE_SNIPPET) {
      let newContent = await saveContent(post.id, {
        type: ContentType.FILE,
        actions: ["CREATING_SNIPPET_IMAGE"],
        value: text,
        meta: {
          name: options && options.filename ? `${options.filename}.png` : "...",
        },
      });
      createSnippetRequest(
        text,
        post.id,
        newContent.id as string,
        options as CodeSnippetOptions
      );
      closePopUp();
    }
  } catch (err) {
    console.error(err);
    showAlertPopUp("There is a problem saving your text.");
  }
};
export const manageText = (
  post: Post,
  content?: Content,
  onDone?: Function
) => {
  showPopUp(
    <ContentText
      onSave={(text, options) =>
        handleTextSave(post, text, content as Content, options).then(() => {
          if (onDone) onDone();
        })
      }
      onClose={closePopUp}
      defaultText={content ? content.value : ""}
    />,
    {
      width: "100%",
      closeOnEsc: true,
    }
  );
};

export default function AddText({
  post,
  buttonClassName,
  noIcon,
  onDone,
}: {
  post: Post;
  buttonClassName?: string;
  noIcon?: boolean;
  onDone?: Function;
}) {
  return (
    <button
      type="button"
      className={
        buttonClassName ? buttonClassName : "primary with-icon ib mr1 mb1"
      }
      onClick={() => {
        trackEvent("add-content-text");
        if (verifyMaxNumberOfContentItems(post.content)) {
          manageText(post, undefined, onDone);
        }
      }}
    >
      {!noIcon && <Type size={20} />} Add text
    </button>
  );
}
